export const customerInfoLayout = {
  "div.grid.grid-cols-1": {
    div: {
      slot: "customer-info-title"
    },
    "div.grid.grid-cols-2.gap-x-30": {
      "div.col-span-1.md-col-span-2:0": { field: "buyer_name" },
      "div.col-span-1.md-col-span-2:1": { field: "buyer_type" },
      "div.col-span-1.md-col-span-2:2": { field: "buyer_legal_name" },
      "div.col-span-1.md-col-span-2:3": { field: "buyer_taxcode" },
      "div.col-span-1.md-col-span-2:4": { field: "buyer_address" },
      "div.col-span-1.md-col-span-2:5": { field: "buyer_email" },
      "div.col-span-1.md-col-span-2:6": { field: "buyer_phone_number" },
      "div.col-span-1.md-col-span-2:8": { field: "buyer_id_no" },
      "div.col-span-1.md-col-span-2:9": { field: "mdvqhnsach" },
      "div.col-span-1.md-col-span-2:10": { field: "buyer_passport_no" }
    }
  }
};

export const invoiceInfoLayout = {
  "div.grid.grid-cols-1:0": {
    div: {
      slot: "invoice-info-title"
    },
    "div.grid.grid-cols-2.gap-x-30": {
      "div.col-span-1.md-col-span-2": { field: "invoice_type" },
      "div.col-span-1.md-col-span-2:0": { field: "template_code" },
      "div.col-span-1.md-col-span-2:1": { field: "invoice_number" },
      "div.col-span-1.md-col-span-2:2": { field: "invoice_common_code" },
      "div.col-span-1.md-col-span-2:3": { field: "date_created" },
      "div.col-span-1.md-col-span-2:4": { field: "payment_method" },
      "div.col-span-1.md-col-span-2:5": { field: "currency_code" },
      "div.col-span-1.md-col-span-2:6": { field: "foreign_rate" }
    }
  }
};

export const deliveryInfoLayout = {
  "div.grid.grid-cols-1:1": {
    div: {
      slot: "delivery-info-title"
    },
    "div.grid.grid-cols-2.gap-x-30": {
      "div.col-span-1.md-col-span-2": { field: "NBan_LDDNBo" },
      "div.col-span-1.md-col-span-2:0": { field: "NBan_PTVChuyen" },
      "div.col-span-1.md-col-span-2:1": { field: "NBan_HDSo" },
      "div.col-span-1.md-col-span-2:2": { field: "NBan_DChi" },
      "div.col-span-1.md-col-span-2:3": { field: "NBan_TNVChuyen" },
      "div.col-span-1.md-col-span-2:4": { field: "NBan_HVTNXHang" }
    }
  }
};

export const additionalInfoLayout = {
  "div.grid.grid-cols-1:2": {
    div: {
      slot: "additional-info-title"
    },
    "div.grid.grid-cols-2.gap-x-30": {
      "div.col-span-1.md-col-span-2": { field: "reason_change" },
      "div.col-span-1.md-col-span-2:0": { field: "evidence_for_change" },
      "div.col-span-1.md-col-span-2:1": { field: "note_change" }
    },
    "div:0": {
      slot: "additional-info-note"
    }
  }
};

export const layout = {
  ...customerInfoLayout,
  ...invoiceInfoLayout,
  ...deliveryInfoLayout,
  ...additionalInfoLayout
};

export default layout;



// WEBPACK FOOTER //
// ./src/portal-components/invoice/actions-invoice/form-configs/layout.js